export const PATH_DASHBOARD = "/member/dashboard";
